import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { getCalculatedAddedAmount } from './HolidayFactor';
import { RegularRate, callBackFactor, callBackRate } from 'app/models/Placement/PlacementMods';
import { isNumber } from '../../../ModificationsUtils';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from '../../BillRate/HourlyRates/BillOrientation';

export const CallBackFactor = ({
  classes,
  currentMod,
  isModEdit,
}: {
  classes: any;
  currentMod?: string;
  isModEdit?: boolean;
}) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const callBackFactorValue = useWatch<any>({ name: callBackFactor });
  const regularRateValue = useWatch<string>({ name: RegularRate });

  return (
    <Grid className={currentMod ? null : classes.rateMargin}>
      <Controller
        name={callBackFactor}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={callBackFactorValue}
            variant="filled"
            label={`${t(`placement.placementMods.${callBackFactor}`)}`}
            helperText={
              regularRateValue ? getCalculatedAddedAmount(getValues, callBackFactor, 'Call Back') : getInvalidAmount()
            }
            className={currentMod ? classes.billFactorTextfields : classes.factorTextfields}
            InputLabelProps={{
              shrink: callBackFactorValue,
            }}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                setValue(callBackFactor, e.target.value);
                onChange(e.target.value);
                setValue(callBackRate, '');
              }
            }}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>
                  {isNumber(callBackFactorValue) && (
                    <InputAdornment position="start">
                      <CloseIcon className={classes.iconClass} />
                    </InputAdornment>
                  )}
                </>
              ),
            }}
            {...rest}
          />
        )}
      />
    </Grid>
  );
};
